export const blockIconsEditorChecklistRtl = (
	<span className='material-symbols-outlined'>checklist_rtl</span>
);
